<script lang="ts" setup>
import { computed, type PropType } from 'vue';
import { FormElement } from '@common';

const props = defineProps({
  element: {
    type: Object as PropType<FormElement>,
    required: true
  }
});

const name = computed(() => props.element.value);
const traditional = computed(() => (props.element.parent?.value as any)?.traditional === true);
</script>

<template>
  <div class="d-flex ga-2 align-center">
    <span>{{ name }}</span>
    <span v-if="traditional">
      <v-icon
        size="large"
        icon="mdi-tractor" />
      <v-tooltip
        activator="parent"
        location="top"
        :text="$t('parcel.tooltip.traditional')" />
    </span>
  </div>
</template>
